import {createActions} from 'redux-actions';

export const {searchActions} = createActions({
	searchActions: {
		getResults: [payload => payload, (payload, meta) => meta],
		setResults: [payload => payload, (payload, meta) => meta],
		appendResults: [payload => payload, (payload, meta) => meta],
		getCountByOffer: [payload => payload, (payload, meta) => meta],
	}
});